import { Card } from 'components/Card/Card';
import { CardItem } from 'components/Card/CardItem';
import { useEffect, useState } from 'react';
import { getHotelOccupancy } from 'repository/hotelOccupancy';
import { THotelOccupancy } from 'types/hotelOccupancy';
import { globalDashboard } from 'helpers/configHelper';
import { i18n } from 'helpers/i18nHelper';
import { FraicheurAnchor } from 'atoms/Anchor';

import { OccupationChart } from './OccupationChart';

const { labels: DashboardLabels } = globalDashboard;

const OccupationPlanning = (): JSX.Element => {
    const [nbDays, setNbDays] = useState<number>(7);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [occupancyData, setOccupancyData] = useState<THotelOccupancy | null>(null);
    // const [openQuickUpdates, setOpenQuickUpdates] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);

            const data = await getHotelOccupancy(nbDays);

            setOccupancyData(data);
            setIsLoading(false);
        };

        fetchData();
    }, [nbDays]);

    const buildChart = (): JSX.Element => {
        return (
            <>
                {/*<div className="avp-tabs tabs--secondary">
                <span className="tabs-label u-visually-hidden">Period:</span>
                <span className="tabs-tab-list">
                <button
                className="tabs-tab"
                type="button"
                aria-selected="true">
                Rates
                </button>

                <button
                className="tabs-tab"
                type="button"
                aria-selected="false">
                Rooms
                </button>
                </span>
                </div>*/}

                <div className="chart u-margin-top-medium">
                    <OccupationChart data={occupancyData} />
                </div>
            </>
        );
    };

    return (
        <section id="bookingOccupancySectionId" className="occupation-planning">
            <div className="ctx-home-head u-margin-top-xlarge">
                <div>
                    <h1>{DashboardLabels.OccupationPlanning.title}</h1>
                    <p className="u-margin-top-medium">{DashboardLabels.OccupationPlanning.subtitle}</p>
                </div>

                <div>
                    {/* <div className="avp-button-dropdown button-dropdown--tertiary" data-component="button-dropdown">
                        <button
                            id="quickUpdateButtonId"
                            className="button-dropdown-button"
                            type="button"
                            title="Toggle Quick updates"
                            data-component="button-menu"
                            onClick={() => setOpenQuickUpdates(!openQuickUpdates)}
                        >
                            Quick updates
                            <i className="button-dropdown-button-icon" aria-hidden="true"></i>
                        </button>

                        <div
                            id="quickUpdateMenuId"
                            className="button-dropdown-body button-dropdown-body--small is-align-left"
                            style={{ display: openQuickUpdates ? 'block' : 'none' }}
                        >
                            <ul className="button-dropdown-menu">
                                <li className="button-dropdown-menu-item">
                                    <a className="button-dropdown-menu-link">Daily</a>
                                </li>
                                <li className="button-dropdown-menu-item">
                                    <a className="button-dropdown-menu-link">Weekly</a>
                                </li>
                                <li className="button-dropdown-menu-item">
                                    <a className="button-dropdown-menu-link">Monthly</a>
                                </li>
                                <li className="button-dropdown-menu-item">
                                    <a className="button-dropdown-menu-link">Yearly</a>
                                </li>
                                <li className="button-dropdown-menu-item is-separator">
                                    <a className="button-dropdown-menu-link">Define a period</a>
                                </li>
                            </ul>
                        </div>
                    </div> */}

                    <FraicheurAnchor
                        id="ManagePlanningDashboardLink"
                        targetFrameName="Planning"
                        href="/Planning/Monthly"
                        childrenText={DashboardLabels.OccupationPlanning.managePlanning}
                    />
                </div>
            </div>

            <div className="avp-tabs tabs--primary u-margin-top-large">
                <span className="tabs-label">{DashboardLabels.period}:</span>
                <span className="tabs-tab-list">
                    <button
                        id="nextWeekButtonId"
                        className="tabs-tab"
                        type="button"
                        aria-selected={nbDays === 7 ? 'true' : 'false'}
                        onClick={() => setNbDays(7)}
                    >
                        {i18n(DashboardLabels.nextXDays, { number: 7 })}
                    </button>

                    <button
                        id="nextMonthButtonId"
                        className="tabs-tab"
                        type="button"
                        aria-selected={nbDays === 30 ? 'true' : 'false'}
                        onClick={() => setNbDays(30)}
                    >
                        {i18n(DashboardLabels.nextXDays, { number: 30 })}
                    </button>
                </span>
            </div>

            <Card
                title={i18n(DashboardLabels.theNextXDays, { number: nbDays })}
                className="u-margin-top-medium"
                option={buildChart()}
                childrenClassName="avp-key-value"
                isLoading={isLoading}
            >
                <>
                    <CardItem
                        label={DashboardLabels.OccupationPlanning.digitalOccupancyRate}
                        content={`${occupancyData?.totalOccupancyPercentage ?? 0}%`}
                        isLoading={isLoading}
                    />

                    <CardItem
                        label={DashboardLabels.OccupationPlanning.provisionalRevenue}
                        content={`${occupancyData?.totalAmount ?? 0}€`}
                        isLoading={isLoading}
                    />
                </>
            </Card>
        </section>
    );
};

export default OccupationPlanning;
